/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Keep_GoingInputs */



/**
* | output |
* | --- |
* | "Keep going" |
*
* @param {Practice_Session_Keep_GoingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_keep_going = /** @type {((inputs?: Practice_Session_Keep_GoingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Keep_GoingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Doorgaan")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer")
	return /** @type {LocalizedString} */ ("Keep going")
});